export const BODY_PATTERN_FIELDS = [
  {
    key: 'vault_peg_hind',
    label: 'Vault / peg-leg hind',
    hint: 'One hind plants like a kickstand. Short flight time.',
  },
  {
    key: 'head_as_lever',
    label: 'Head used as a lever',
    hint: 'Neck and poll doing the balancing.',
  },
  {
    key: 'barrel_one_way',
    label: 'Barrel only one way',
    hint: 'Ribcage/barrel only on one diagonal. Side-on often cannot show this.',
  },
  {
    key: 'front_compensation',
    label: 'Front as compensation',
    hint: 'Fronts look busy because the hind or barrel is offline.',
  },
];

export const BODY_PATTERN_VALUES = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'cant_see', label: "Can't see" },
];

export const EMPTY_BODY_PATTERN_TICKS = {
  vault_peg_hind: null,
  head_as_lever: null,
  barrel_one_way: null,
  front_compensation: null,
};

export function ticksFromRow(row) {
  if (!row) return { ...EMPTY_BODY_PATTERN_TICKS };
  return {
    vault_peg_hind: row.vault_peg_hind || null,
    head_as_lever: row.head_as_lever || null,
    barrel_one_way: row.barrel_one_way || null,
    front_compensation: row.front_compensation || null,
  };
}

export function hasAnyTick(ticks) {
  return BODY_PATTERN_FIELDS.some((field) => ticks?.[field.key]);
}

export function payloadForUpsert(videoId, userId, ticks) {
  return {
    video_id: videoId,
    user_id: userId,
    vault_peg_hind: ticks.vault_peg_hind || null,
    head_as_lever: ticks.head_as_lever || null,
    barrel_one_way: ticks.barrel_one_way || null,
    front_compensation: ticks.front_compensation || null,
    updated_at: new Date().toISOString(),
  };
}

export async function fetchBodyPatternTicks(supabase, userId, videoIds) {
  if (!userId || !videoIds?.length) return {};
  const { data, error } = await supabase
    .from('body_pattern_ticks')
    .select('*')
    .eq('user_id', userId)
    .in('video_id', videoIds);
  if (error) throw error;
  const map = {};
  (data || []).forEach((row) => {
    map[row.video_id] = row;
  });
  return map;
}

export async function upsertBodyPatternTicks(supabase, videoId, userId, ticks) {
  const { data, error } = await supabase
    .from('body_pattern_ticks')
    .upsert(payloadForUpsert(videoId, userId, ticks), { onConflict: 'video_id,user_id' })
    .select()
    .single();
  if (error) throw error;
  return data;
}
